import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LeftSidebar from '../components/LeftSidebar';
import RightSidebar from '../components/RightSidebar';
import Header from '../components/Header';

const DashboardLayout = () => {
  // Detector de ancho de pantalla para estado inicial
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // En móvil empieza cerrado (true), en escritorio abierto (false)
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(window.innerWidth <= 768);

  const location = useLocation();

  // Escuchar cambios de tamaño de ventana
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        // En escritorio, restaurar comportamiento normal si se desea, 
        // o dejarlo como estaba. Aquí forzamos expandir si pasa a escritorio (opcional)
        setSidebarCollapsed(false);
      } else {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Cerrar el menú automáticamente al navegar en móvil
  useEffect(() => {
    if (isMobile) {
      setSidebarCollapsed(true);
    }
  }, [location, isMobile]);

  // Función para cambiar el estado (Toggle)
  const toggleSidebar = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    // Se añade clase para móvil si aplica
    <div className={`dashboard-container ${isSidebarCollapsed ? 'sidebar-collapsed' : ''} ${isMobile ? 'is-mobile' : ''}`}>

      {/* Overlay para cerrar menú en móvil al hacer click fuera */}
      {isMobile && !isSidebarCollapsed && (
        <div
          className="mobile-overlay"
          onClick={() => setSidebarCollapsed(true)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999
          }}
        />
      )}

      {/* Se pasa el estado y la función como props a los hijos */}
      <LeftSidebar isCollapsed={isSidebarCollapsed} isMobile={isMobile} />
      <Header toggleSidebar={toggleSidebar} isMobile={isMobile} />

      <main className="main-content-area">
        <Outlet />
      </main>

      {/* Sidebar derecho se oculta en móvil vía CSS, pero lo mantenemos en el DOM por estructura */}
      <RightSidebar />
    </div>
  );
};

export default DashboardLayout;